
import "./MatchStats.scss";
import NoData from "@/components/client/NoData";
import LiveStats from "@/components/client/LiveStats";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;

export default function MatchStats({ match }) {
  return (
    <CollapsiblePanel
      className="mt-8"
      title="Thống kê kỹ thuật"
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      {match === undefined || match === null ? (
        <NoData />
      ) : (
        <div className="rounded overflow-hidden mt-5">
          <LiveStats matchId={match.id} />
        </div>
      )}
    </CollapsiblePanel>
  );
}
